import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormControl } from '@angular/forms';

declare var require: any;

@Component({
  selector: 'app-conversation-log-simple',
  templateUrl: './conversation-log-simple.component.html',
  styleUrls: ['./conversation-log-simple.component.scss']
})

export class ConversationLogSimpleComponent implements OnInit, OnDestroy {

  private readonly notifier: NotifierService;

  profileForm = new FormGroup({
    converstationComment: new FormControl(''),
    converstationMsg: new FormControl(''),
    selectedIntent: new FormControl(''),
    optionValue: new FormControl('')
  });

  @Input('Converstation')
  converstation: any = [];

  @Input('ConversationId')
  conversationId: any = "";

  @Input('IntentSkills')
  intentSkills: any = [];

  @Input('isLoading')
  isLoading: boolean = false;

  @Output('getConversationList')
  getFullConversationList: EventEmitter<any> = new EventEmitter();

  conversationArr: any = [];
  msgId: any = '';
  selcetedIntentResponse: any = "";
  converStationType = "";
  conversationDocumentId = "";
  // converstationComment:string = "";

  // Images
  messageIcon: string = require('../../assets/images/ic_message-bubble.svg');
  dotsIcon: string = require('../../assets/images/ic_dots.svg');
  dotsHIcon: string = require('../../assets/images/ic_dotsH.svg');
  editIcon: string = require('../../assets/images/ic_edit.svg');
  editHIcon: string = require('../../assets/images/ic_editH.svg');
  userIcon: string = require('../../assets/images/ic_message-bubble_user.svg');
  ovalImagePath: string = require('../../assets/images/Oval.png');

  ratingImagePath1: string = require('../../assets/images/very sad.svg');
  ratingImagePath2: string = require('../../assets/images/sad.svg');
  ratingImagePath3: string = require('../../assets/images/avg.svg');
  ratingImagePath4: string = require('../../assets/images/happy.svg');
  ratingImagePath5: string = require('../../assets/images/very happy.svg');
  
  constructor(private service: ApiService, notifierService: NotifierService) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  AddFeedbackConversation() {
    this.notifier.hideAll();
    if (this.profileForm.value.converstationComment.trim() == "") {
      this.notifier.notify("error", "Please fill the comments");
      return 0;
    }

    if (this.converStationType == "incoming") {
      if (this.profileForm.value.optionValue == "") {
        this.notifier.notify("error", "Please select the option");
        return 0;
      }
      if (this.profileForm.value.optionValue == "yes") {
        if (this.profileForm.value.selectedIntent == "") {
          this.notifier.notify("error", "Please select the intent");
          return 0;
        }

        if (this.profileForm.value.converstationMsg.trim() == "") {
          this.notifier.notify("error", "Please fill the phrase");
          return 0;
        }
      } else {
        this.profileForm.patchValue({
          converstationMsg: ""
        });
      }
    } else {
      this.profileForm.patchValue({
        converstationMsg: "",
        selectedIntent: "",
        optionValue: ""
      });
    }

    // var body = {
    //   "comments" : this.profileForm.value.converstationComment,
    //   "conversation_id" : this.conversationId,
    //   "user_id" : this.conversationArr.user_id,
    //   "comment_opt" : this.profileForm.value.optionValue,
    //   "type" : this.converStationType,
    //   "intent_id" : this.profileForm.value.selectedIntent,
    //   "io_id": this.conversationArr.id,
    //   "training_phrase": this.profileForm.value.converstationMsg
    // }

    return this.service.addFeedbackConversation(this.conversationId, this.conversationDocumentId, this.profileForm.value.selectedIntent, this.profileForm.value.converstationMsg, this.profileForm.value.converstationComment, this.converStationType).subscribe((data: {}) => {
      if (data["status"] == 200 || data["status"] == 201) {
        console.log("data ", data)

        this.profileForm.patchValue({
          converstationComment: "",
          converstationMsg: "",
          optionValue: ""
        });

        this.conversationArr = [];
        this.converStationType = "";
        this.profileForm.value.selectedIntent = "";
        this.notifier.notify("success", "Feedback added succesfully.");
      } else {
        this.notifier.notify("error", data["status_details"] + "\n" + data["fields"]);
      }
    })
  }

  GetConversation(conversation: any, index: any) {

    if (this.msgId == conversation.id && this.converStationType == conversation.type) {
      this.converStationType = "";
      this.msgId = "";
      this.conversationArr = [];
      this.profileForm.patchValue({
        converstationMsg: "",
        selectedIntent: ""
      });
      return 0;
    }

    if (conversation.type == "outgoing") {
      for (let i = index; i < this.converstation.length; i++) {

        if (i == this.converstation.length - 1) {
          this.msgId = this.converstation[i].id;
          this.converStationType = conversation.type;
          this.conversationDocumentId = conversation.document_id;
          this.conversationArr = conversation;
          this.profileForm.patchValue({
            converstationMsg: conversation.text,
            selectedIntent: "",
            optionValue: ""
          });
          i = this.converstation.length;
          return 0;
          break;
        }

        if (this.converstation[i].type == "incoming") {
          console.log("conversation", i, index, this.converstation.length, this.converstation[i].id, conversation.type);
          this.converStationType = conversation.type;
          this.conversationDocumentId = conversation.document_id;
          this.msgId = this.converstation[--i].id;
          this.conversationArr = conversation;
          this.profileForm.patchValue({
            converstationMsg: conversation.text,
            selectedIntent: "",
            optionValue: ""
          });
          i = this.converstation.length;
          return 0;
          break;
        }
      }
    }

    this.conversationDocumentId = conversation.document_id;
    this.converStationType = conversation.type;
    this.msgId = conversation.id;
    this.conversationArr = conversation;
    this.profileForm.patchValue({
      converstationMsg: conversation.text,
      selectedIntent: "",
      optionValue: ""
    });
  }

  getFilteredValues(event: any) {
    var filteredArray = event;
    var intentSkills = [];

    for (var i = 0; i < filteredArray.length; i++) {
      intentSkills.push(filteredArray[i]);
    }

    for (var i = 0; i < this.intentSkills.length; i++) {
      var intentSkill = filteredArray.filter(e => e.id == this.intentSkills[i].id);
      if (intentSkill.length == 0) {
        intentSkills.push(this.intentSkills[i])
      }
    }

    console.log('intentSkills ', intentSkills)

    this.intentSkills = intentSkills;
    return intentSkills;
  }

  public onChangeObj(event: any) {
    this.profileForm.patchValue({
      selectedIntent: event
    });
    this.selcetedIntentResponse = this.intentSkills.filter(e => e.id == event)[0].Response;
  }

  public handleChange(event: any) {
    this.profileForm.patchValue({
      optionValue: event.value
    });
  }

  ClearDialog() {
    this.converStationType = "";
    this.msgId = "";
    this.conversationArr = "";
    this.profileForm.patchValue({
      optionValue: ""
    });
  }

  checkNullOrEmpty(data) {
    if (data.toString() == "null") {
      return 0;
    }

    if (JSON.parse(data).length == 0) {
      return 0;
    }

    return 1;
  }

  CompleteFeedback() {
    return this.service.completeFeedBackStatus(this.conversationId).subscribe((data: {}) => {
      if (data["status"] == 200 || data["status"] == 201) {
        console.log("data ", data)
        this.notifier.notify("success", "Feedback added succesfully.");
        this.getFullConversationList.emit();
      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }

  parseJSON(text) {
    return JSON.parse(text);
  }

  isShowIncomingMessage(msg) {
    if (msg.type == 'incoming' && (msg.text || msg.quick_reply)) {
      return true;
    }

    return false;
  }
}